import React from "react";
import { Check, Zap, Cpu, Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function Gebaudeautomation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const features = [{
    icon: <Settings className="w-5 h-5" />,
    title: "Individuelle Planung",
    description: "Massgeschneiderte Konzepte für Neubau, Umbau oder Nachrüstung. Exakt auf Ihre Bedürfnisse und Ihr Budget abgestimmt."
  }, {
    icon: <Zap className="w-5 h-5" />,
    title: "Loxone Smart‑Home Integration",
    description: "Als zertifizierter Loxone Partner realisieren wir durchgängige Automationslösungen für Licht, Beschattung, Heizung, Lüftung, Sicherheit und Multimedia."
  }, {
    icon: <Cpu className="w-5 h-5" />,
    title: "Energie & Systeme intelligent vernetzt",
    description: "PV-Anlage, Wärmepumpe, Speicher und Wallbox werden optimal in das Loxone Smart-Home integriert. Für maximale Eigenverbrauchsnutzung und Komfort."
  }];
  return <section id="gebäudeautomation" ref={ref} className={cn("dark bg-background text-foreground py-20 lg:py-32 relative overflow-hidden transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")} style={{
    "--primary": "hsl(215 95% 50%)",
    "--secondary": "hsl(30 40% 45%)",
    "--background": "hsl(220 10% 8%)",
    "--foreground": "hsl(210 20% 98%)"
  } as React.CSSProperties}>
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-primary/5 rounded-lg blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[30%] h-[30%] bg-primary/10 rounded-lg blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col lg:flex-row items-center">
          
          {}
          <div className="w-full lg:w-7/12 relative mb-12 lg:mb-0">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-border/30 group">
              <div className="absolute inset-0 bg-gradient-to-r from-background/90 via-background/50 to-transparent z-10" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557665/img/f3e67e1f-e27b-4f21-b357-4f3ee6d87470.jpg" alt="Modernes Smart Home Interieur mit Steuerungspanel" className="w-full h-[400px] lg:h-[600px] object-cover transform transition-transform duration-700 group-hover:scale-105" />
              
              {}
              <div className="absolute bottom-6 left-6 z-20 bg-card/90 backdrop-blur-md border border-primary/20 p-4 rounded-lg shadow-lg max-w-[200px]">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-2 h-2 rounded-lg bg-primary animate-pulse" />
                  <span className="text-xs font-mono text-primary uppercase tracking-wider">System Active</span>
                </div>
                <p className="text-xs text-muted-foreground font-mono">
                  Status: Optimiert<br />
                  Effizienz: 98.4%
                </p>
              </div>
            </div>
          </div>

          {}
          <div className="w-full lg:w-6/12 lg:-ml-24 relative z-20">
            <div className="bg-card/95 backdrop-blur-xl border border-border/50 p-8 lg:p-12 rounded-2xl shadow-2xl lg:shadow-[0_20px_50px_-12px_rgba(0,0,0,0.5)]">
              <div className="mb-6">
                <span className="inline-block py-1 px-3 rounded-lg bg-primary/10 border border-primary/20 text-primary text-xs font-mono tracking-widest uppercase mb-4">
                  Systemintegration
                </span>
                <h2 className="text-3xl lg:text-4xl font-bold tracking-tight text-foreground mb-4">
                  Intelligente Gebäudeautomation
                </h2>
                <p className="text-muted-foreground text-lg leading-relaxed">
                  Wir verbinden Komfort, Sicherheit und Energieeffizienz in einem zentralen, intuitiven Smart-Home-System. Individuell auf Ihr Projekt abgestimmt.
                </p>
              </div>

              <div className="space-y-6 mb-8">
                {features.map((item, i) => <div key={i} data-index={i} className="flex items-start gap-4 group">
                    <div className="mt-1 flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary border border-primary/20 group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                      {item.icon}
                    </div>
                    <div>
                      <h3 className="text-foreground font-semibold mb-1 group-hover:text-primary transition-colors">
                        {item.title}
                      </h3>
                      <p className="text-sm text-muted-foreground leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </div>)}
              </div>

              <div className="flex flex-wrap gap-4 pt-4 border-t border-border/50">
                <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg shadow-primary/20">
                  <Link to="/ContactPage">
                    Beratung anfordern
                  </Link>
                </Button>
                <Button asChild variant="outline" size="lg" className="border-primary/20 hover:bg-primary/5 hover:text-primary hover:border-primary/50">
                  <Link to="/ReferencesPage">
                    Referenzen ansehen
                  </Link>
                </Button>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>;
}